export default __webpack_public_path__ + "static/media/molar-III.174c75dd.png";